import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-v2">
      <div className="footer-v2-inner">

        <div className="footer-v2-grid">
          {/* Brand */}
          <div className="footer-v2-brand">
            <div className="footer-v2-logo">
              <img src="/logo.png" alt="Outsourced" style={{ width: 22, height: 22, borderRadius: 5 }} />
              <span>Outsourced</span>
            </div>
            <p className="footer-v2-tagline">
              Your trusted source for premium Discord services — instant delivery, competitive pricing, and support that replies.
            </p>
            <div className="footer-v2-socials">
              <a href="https://discord.gg/outsourced" target="_blank" rel="noreferrer" className="footer-v2-social" aria-label="Discord">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/></svg>
              </a>
              <a href="https://t.me/outsourced" target="_blank" rel="noreferrer" className="footer-v2-social" aria-label="Telegram">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
              </a>
            </div>
          </div>

          <div className="footer-v2-col">
            <h4 className="footer-v2-col-title">Quick Links</h4>
            <Link to="/" className="footer-v2-link">Home</Link>
            <Link to="/#products" className="footer-v2-link">Products</Link>
            <Link to="/#features" className="footer-v2-link">Features</Link>
            <Link to="/docs" className="footer-v2-link">FAQ</Link>
            <Link to="/order-status" className="footer-v2-link">Track Order</Link>
          </div>

          <div className="footer-v2-col">
            <h4 className="footer-v2-col-title">Support</h4>
            <a href="https://discord.gg/outsourced" target="_blank" rel="noreferrer" className="footer-v2-link">
              Discord Server
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{marginLeft:4}}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            </a>
            <Link to="/terms" className="footer-v2-link">Terms of Service</Link>
            <Link to="/status" className="footer-v2-link">System Status</Link>
          </div>

          <div className="footer-v2-col">
            <h4 className="footer-v2-col-title">Products</h4>
            <Link to="/#products" className="footer-v2-link">Discord Boosts</Link>
            <Link to="/#products" className="footer-v2-link">Server Boosts</Link>
            <Link to="/docs" className="footer-v2-link">Tools</Link>
            <Link to="/#auto-reboost" className="footer-v2-link">Auto-Reboost</Link>
          </div>
        </div>

        <div className="footer-v2-divider" />

        <div className="footer-v2-bottom">
          <span className="footer-v2-copy">© 2026 Outsourced. All rights reserved.</span>
          <a href="https://outsourced.rip" className="footer-v2-built" target="_blank" rel="noreferrer">outsourced.rip</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
